export enum MessageType {
  CONFIG = 'config',
  EVENT = 'event',
  STATUS = 'status',
  OUT = 'out',
  MESSAGE = 'message',
}
